import { useInstruktioner } from './useInstruktioner';
import { useLasstatus } from './useLasstatus';
import { uppdateradSedanLast } from '../utils/lasstatus';

/** Antal instruktioner som ändrats sedan användaren läste dem (sidomenyns siffra). */
export function useUppdateradeAntal() {
  const { poster } = useInstruktioner();
  const status = useLasstatus();
  return poster.filter((p) => p.publicerad && !p.variant_av && uppdateradSedanLast(p, status)).length;
}
